"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var rc_motion_1 = tslib_1.__importDefault(require("rc-motion"));
var legacyUtil_1 = require("../utils/legacyUtil");
function Mask(props) {
    var prefixCls = props.prefixCls, visible = props.visible, zIndex = props.zIndex, mask = props.mask, maskMotion = props.maskMotion, maskAnimation = props.maskAnimation, maskTransitionName = props.maskTransitionName;
    if (!mask) {
        return null;
    }
    var motion = {};
    if (maskMotion || maskTransitionName || maskAnimation) {
        motion = tslib_1.__assign({ motionAppear: true }, (0, legacyUtil_1.getMotion)({
            motion: maskMotion,
            prefixCls: prefixCls,
            transitionName: maskTransitionName,
            animation: maskAnimation,
        }));
    }
    return (React.createElement(rc_motion_1.default, tslib_1.__assign({}, motion, { visible: visible, removeOnLeave: true }), function (_a) {
        var className = _a.className;
        return (React.createElement("div", { style: { zIndex: zIndex }, className: (0, classnames_1.default)("".concat(prefixCls, "-mask"), className) }));
    }));
}
exports.default = Mask;
//# sourceMappingURL=Mask.js.map